module.exports = __webpack_public_path__ + "img/item_estate@2x.08f8d886.png";